module.exports = __webpack_public_path__ + "img/api_img03.d75e41d9.png";